<div class="view-container">
  <mat-card class="log-list-container">
    <div class="log-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>history</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Logs</h1>
      </div>

      <div class="log-list__filters">
        <mat-form-field
          appearance="outline"
          floatLabel="always"
          class="log-list__filter log-list__filter--date"
          subscriptSizing="dynamic"
        >
          <mat-label>Filter by date</mat-label>
          <mat-date-range-input
            [formGroup]="dateRangeForm"
            [rangePicker]="dateRangePicker"
            [comparisonStart]="dateRangeForm.value.start_date"
            [comparisonEnd]="dateRangeForm.value.end_date"
          >
            <input matStartDate placeholder="Start date" formControlName="start_date" />
            <input matEndDate placeholder="End date" formControlName="end_date" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="dateRangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #dateRangePicker></mat-date-range-picker>
        </mat-form-field>
      </div>
    </div>

    <mat-paginator
      class="log-list__paginator"
      [length]="totalNumberOfLogs"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="[10, 15, 20]"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of logs"
    >
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="logsDataSource" class="mbp-data-table log-list">
        <ng-container matColumnDef="entity_id">
          <th mat-header-cell *matHeaderCellDef>Entity id</th>
          <td mat-cell *matCellDef="let log">{{ log.entity_id }}</td>
        </ng-container>

        <ng-container matColumnDef="entity">
          <th mat-header-cell *matHeaderCellDef class="name-col">Entity</th>
          <td mat-cell *matCellDef="let log" class="name-col">{{ log.entity }}</td>
        </ng-container>

        <ng-container matColumnDef="log_type">
          <th mat-header-cell *matHeaderCellDef>Log type</th>
          <td mat-cell *matCellDef="let log">{{ log.log_type }}</td>
        </ng-container>

        <ng-container matColumnDef="date_and_time">
          <th mat-header-cell *matHeaderCellDef>Date and time</th>
          <td mat-cell *matCellDef="let log">
            {{ utilService.toDateString(log.created_at) }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          (click)="viewLog(row)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>

        <tr class="log-list__empty-row" *matNoDataRow>
          <td class="log-list__empty-cell" [attr.colspan]="displayedColumns.length">
            No logs found for the selected filters.
          </td>
        </tr>
      </table>
    </div>
  </mat-card>
</div>
